import { useState } from "react";
import { Form } from "react-bootstrap";
import './Services.css';

export default function Services() {
    const [price, setPrice] = useState('120');

    const prices = [
        { name: 'Pine', price: 120 },
        { name: 'Aspen', price: 125 },
        { name: 'Poplar', price: 130 },
        { name: 'Cedar', price: 135 },
        { name: 'Red Oak', price: 140 }
    ];
    const styles = {
        cardHover: {
            transform: 'translateY(-8px)',
            boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)',
        }
    }

    const handleMouseEnter = (e) => {
        e.currentTarget.style.transform = styles.cardHover.transform;
        e.currentTarget.style.boxShadow = styles.cardHover.boxShadow;
    };

    const handleMouseLeave = (e) => {
        e.currentTarget.style.transform = 'none';
        e.currentTarget.style.boxShadow = 'none';
    };

    return (
        <>
            <div>
                <div className="container">
                    <div className="grid">
                        <div 
                            className="card" 
                            onMouseEnter={handleMouseEnter} 
                            onMouseLeave={handleMouseLeave}
                        >
                            <h3 className="serviceName">Skull Only</h3>
                            <div className="price">
                                <span className="priceSymbol">$</span>
                                100
                            </div>
                            <p className="description">Includes skinning, cleaning, & whitening.</p>
                        </div>
                        <div 
                            className="card" 
                            onMouseEnter={handleMouseEnter} 
                            onMouseLeave={handleMouseLeave}
                        >
                            <h3 className="serviceName">Plaque Mounts</h3>
                            <div className="price">
                                <span className="priceSymbol">$</span>
                                {price}
                            </div>
                            <Form.Select
                                    className="my-2"
                                    onChange={(e) => {setPrice(e.target.value)}}
                                >
                                    {prices.map((item) => (
                                        <option value={item.price}>{item.name}</option>
                                    ))}
                                </Form.Select>
                            <p className="description">Includes skinning, cleaning, whitening & plaque mounting. Custom plaque designs may incur additional fees.</p>
                        </div>
                        <div 
                            className="card" 
                            onMouseEnter={handleMouseEnter} 
                            onMouseLeave={handleMouseLeave}
                        >
                            <h3 className="serviceName">Antlers Only</h3>
                            <div className="price">
                                <span className="priceSymbol">$</span>
                                50
                            </div>
                            <p className="description">Includes cleaning & mounting. Option of replica skull or velvet cap.</p>
                        </div>
                    </div>
                </div>
            </div>
            {/* <Card>
                <Card.Body>
                    <Card.Title>Pricing</Card.Title>
                    <Card.Text>
                        <div className="d-flex flex-wrap my-2">
                            <Card style={{ width: '30rem' }}>
                                <Card.Body>
                                    <div className="d-flex flex-column align-items-center p-3 price-box">
                                        <h3>Skull Only</h3>
                                        <h2>$100</h2>
                                        <p>Includes skinning, cleaning, & whitening.</p>
                                    </div>
                                </Card.Body>
                            </Card>
                            <Card style={{ width: '30rem' }}>
                                <Card.Body>
                                    <div className="d-flex flex-column align-items-center p-3 price-box">
                                        <h3>Plaque Mounts</h3>
                                        <Form.Select
                                            className="my-2"
                                            onChange={(e) => {setPrice("$" + e.target.value)}}
                                        >
                                            <option value="120">Pine</option>
                                            <option value="125">Aspen</option>
                                            <option value="130">Poplar</option>
                                            <option value="135">Cedar</option>
                                            <option value="140">Red Oak</option>
                                        </Form.Select>
                                        <h2>{price}</h2>
                                        <p>Includes skinning, cleaning, whitening & plaque mounting. Custom plaque designs may incur additional fees.</p>
                                    </div>
                                </Card.Body>
                            </Card>
                            <Card style={{ width: '30rem' }}>
                                <Card.Body>
                                    <div className="d-flex flex-column align-items-center p-3 price-box">
                                        <h3>Antlers Only</h3>
                                        <h2>$50</h2>
                                        <p>Includes cleaning & mounting. Option of replica skull or velvet cap.</p>
                                    </div>
                                </Card.Body>
                            </Card>
                        </div>
                        <p>A $5 discount will be applied if skull is recieved already skinned.</p>
                        <p>Will accept cash, check, and Venmo.</p>
                        <span><i>Prices subject to change.</i></span>
                    </Card.Text>
                </Card.Body>
            </Card> */}
        </>
    );
}